import { render, staticRenderFns } from "./UnityList.vue?vue&type=template&id=525fb75e&"
import script from "./UnityList.vue?vue&type=script&lang=js&"
export * from "./UnityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports